import template from 'underscore.template';
import moment from 'moment';
import 'clndr';

const CALENDAR_SELECTOR = '.js-calendar';
const CALENDAR_NEXT_TITLE_SELECTOR = '.js-calendar-next-title';
let calendarSettings = {
  weekOffset: 1,
  targets: {
    nextButton: 'js-calendar-next',
    todayButton: 'clndr-today-button',
    previousButton: 'js-calendar-prev',
  },
  clickEvents: {
    onMonthChange: (month) => {
      setNextMonthTitle(month);
    }
  }
};

/* eslint-disable */
const init = () => {
  if (typeof calendarEvents === 'undefined' ) {
    return false;
  }

  let calendarTemplate = template($('#clndrTemplate').html());

  calendarSettings.render = (data) => {
    return calendarTemplate(data);
  };

  calendarSettings.moment = moment;
  calendarSettings.events = calendarEvents;

  $(CALENDAR_SELECTOR).clndr(calendarSettings);

  setNextMonthTitle(moment());
};
/* eslint-enable */

const setNextMonthTitle = (month) => {
  let $calendarNextTittle = $(CALENDAR_NEXT_TITLE_SELECTOR);

  if ($calendarNextTittle.length === 0) {
    return false;
  }

  let nextMonth  = month.add(1, 'months');
  let nextTitle = nextMonth.format('MMMM') + ' ' + nextMonth.year();

  $calendarNextTittle.text(nextTitle);
};

export default init;
